import { IDENTITY_TYPES_MAP } from '@verifime/utils';
import { TAssessmentStatus, TCountry, TOption, TRiskLevel, TState } from './types';

export const APPLICATION_NAME = 'VerifiMe Client Portal';

export enum CountryCode {
  AUS = 'AUS',
  NZL = 'NZL',
  BGR = 'BGR',
  BFA = 'BFA',
  CMR = 'CMR',
  COG = 'COG',
  RDC = 'RDC',
  HRV = 'HRV',
  HTI = 'HTI',
  IRN = 'IRN',
  KEN = 'KEN',
  KYA = 'KYA',
  PRK = 'PRK',
  MLI = 'MLI',
  MCO = 'MCO',
  MOZ = 'MOZ',
  MMR = 'MMR',
  NAM = 'NAM',
  NGA = 'NGA',
  PHL = 'PHL',
  SEN = 'SEN',
  ZAF = 'ZAF',
  SSD = 'SSD',
  SYR = 'SYR',
  TZA = 'TZA',
  VEN = 'VEN',
  VNM = 'VNM',
  YEM = 'YEM',
}

export const AUS: TCountry = { code: CountryCode.AUS, label: 'Australia', dialCode: '+61' };
export const NZL: TCountry = { code: CountryCode.NZL, label: 'New Zealand', dialCode: '+64' };
export const BGR: TCountry = { code: CountryCode.BGR, label: 'Bulgaria', dialCode: '+359' };
export const BFA: TCountry = { code: CountryCode.BFA, label: 'Burkina Faso', dialCode: '+226' };
export const CMR: TCountry = { code: CountryCode.CMR, label: 'Cameroon', dialCode: '+237' };
export const COG: TCountry = { code: CountryCode.COG, label: 'Congo', dialCode: '+242' };
export const RDC: TCountry = {
  code: CountryCode.RDC,
  label: 'Democratic Republic of the Congo',
  dialCode: '+243',
};
export const HRV: TCountry = { code: CountryCode.HRV, label: 'Croatia', dialCode: '+385' };
export const HTI: TCountry = { code: CountryCode.HTI, label: 'Haiti', dialCode: '+509' };
export const IRN: TCountry = { code: CountryCode.IRN, label: 'Iran', dialCode: '+98' };
export const KEN: TCountry = { code: CountryCode.KEN, label: 'Kenya', dialCode: '+254' };
export const KYA: TCountry = { code: CountryCode.KYA, label: 'Kyrgyzstan', dialCode: '+996' };
export const PRK: TCountry = { code: CountryCode.PRK, label: 'North Korea', dialCode: '+850' };
export const MLI: TCountry = { code: CountryCode.MLI, label: 'Mali', dialCode: '+223' };
export const MCO: TCountry = { code: CountryCode.MCO, label: 'Monaco', dialCode: '+377' };
export const MOZ: TCountry = { code: CountryCode.MOZ, label: 'Mozambique', dialCode: '+258' };
export const MMR: TCountry = { code: CountryCode.MMR, label: 'Myanmar', dialCode: '+95' };
export const NAM: TCountry = { code: CountryCode.NAM, label: 'Namibia', dialCode: '+264' };
export const NGA: TCountry = { code: CountryCode.NGA, label: 'Nigeria', dialCode: '+234' };
export const PHL: TCountry = { code: CountryCode.PHL, label: 'Philippines', dialCode: '+63' };
export const SEN: TCountry = { code: CountryCode.SEN, label: 'Senegal', dialCode: '+221' };
export const ZAF: TCountry = { code: CountryCode.ZAF, label: 'South Africa', dialCode: '+27' };
export const SSD: TCountry = { code: CountryCode.SSD, label: 'South Sudan', dialCode: '+211' };
export const SYR: TCountry = {
  code: CountryCode.SYR,
  label: 'Syrian Arab Republic',
  dialCode: '+963',
};
export const TZA: TCountry = { code: CountryCode.TZA, label: 'Tanzania', dialCode: '+255' };
export const VEN: TCountry = { code: CountryCode.VEN, label: 'Venezuela', dialCode: '+58' };
export const VNM: TCountry = { code: CountryCode.VNM, label: 'Vietnam', dialCode: '+84' };
export const YEM: TCountry = { code: CountryCode.YEM, label: 'Yemen', dialCode: '+967' };

export const COUNTRY_MAP: { [key: string]: TCountry } = {
  AUS,
  NZL,
  BGR,
  BFA,
  CMR,
  COG,
  RDC,
  HRV,
  HTI,
  IRN,
  KEN,
  KYA,
  PRK,
  MLI,
  MCO,
  MOZ,
  MMR,
  NAM,
  NGA,
  PHL,
  SEN,
  ZAF,
  SSD,
  SYR,
  TZA,
  VEN,
  VNM,
  YEM,
};

export const COUNTRIES: TCountry[] = Object.values(COUNTRY_MAP);

export const STATES: TState[] = [
  { code: 'ACT', label: 'ACT', countryCode: 'AUS' },
  { code: 'NSW', label: 'NSW', countryCode: 'AUS' },
  { code: 'NT', label: 'NT', countryCode: 'AUS' },
  { code: 'QLD', label: 'QLD', countryCode: 'AUS' },
  { code: 'SA', label: 'SA', countryCode: 'AUS' },
  { code: 'TAS', label: 'TAS', countryCode: 'AUS' },
  { code: 'VIC', label: 'VIC', countryCode: 'AUS' },
  { code: 'WA', label: 'ACT', countryCode: 'AUS' },
];

export const GENDERS: TOption[] = [
  { code: 'female', label: 'Female' },
  {
    code: 'male',
    label: 'Male',
  },
  { code: 'other', label: 'Other' },
  { code: 'notToSay', label: 'Prefer not to say' },
];

export enum EntityStatus {
  Empty = 'Empty',
  InProgress = 'InProgress',
  Rejected = 'Rejected',
  Verified = 'Verified',
}

export enum ErrorType {
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
}

export enum ErrorScope {
  Field = 'Field',
  Form = 'Form',
  Global = 'Global',
}

export enum FormStatus {
  UNKNOWN,
  UNFILLED,
  FILLED,
  DOING_UPDATE,
}

export enum DocumentType {
  WholesaleCertificate = 'WholesaleCertificate',
  Passport = 'Passport',
  DriverLicence = 'DriverLicence',
}

export enum RiskLevel {
  Pending = 'Pending',
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  Extreme = 'Extreme',
}

export enum AssessmentStatus {
  Open = 'Open',
  Closed = 'Closed',
  InProgress = 'InProgress',
  NoRisksDetected = 'NoRisksDetected',
}

export const AssessmentStatusOpen: TAssessmentStatus = {
  code: AssessmentStatus.Open,
  label: 'Open',
};

export const AssessmentStatusClosed: TAssessmentStatus = {
  code: AssessmentStatus.Closed,
  label: 'Closed',
};

export const AssessmentStatusNoRisksDetected: TAssessmentStatus = {
  code: AssessmentStatus.NoRisksDetected,
  label: 'No Risks Detected',
};

export const AssessmentStatusInProgress: TAssessmentStatus = {
  code: AssessmentStatus.InProgress,
  label: 'In Progress',
};

export const ASSESSMENT_STATUS: TAssessmentStatus[] = [
  AssessmentStatusOpen,
  AssessmentStatusClosed,
  AssessmentStatusNoRisksDetected,
];

export const RISK_LEVEL_PENDING: TRiskLevel = {
  code: RiskLevel.Pending,
  label: 'Pending',
};

export const RiskLevelLow: TRiskLevel = {
  code: RiskLevel.Low,
  label: 'Low',
};

export const RiskLevelMedium: TRiskLevel = {
  code: RiskLevel.Medium,
  label: 'Medium',
};

export const RiskLevelHigh: TRiskLevel = {
  code: RiskLevel.High,
  label: 'High',
};

export const RiskLevelExtreme: TRiskLevel = {
  code: RiskLevel.Extreme,
  label: 'Extreme',
};

export const RISK_SCORE: Record<string, number> = {
  Low: 1,
  Medium: 2,
  High: 3,
  Extreme: 4,
};

export const RISK_LEVEL_MAP: { [key in RiskLevel]: TRiskLevel } = {
  [RiskLevel.Pending]: RISK_LEVEL_PENDING,
  [RiskLevel.Low]: RiskLevelLow,
  [RiskLevel.Medium]: RiskLevelMedium,
  [RiskLevel.High]: RiskLevelHigh,
  [RiskLevel.Extreme]: RiskLevelExtreme,
};

export const RISK_LEVELS: TRiskLevel[] = Object.values(RISK_LEVEL_MAP);

export enum MitigationStatus {
  Open = 'Open',
  Pass = 'Pass',
  Ignore = 'Ignore',
  Fail = 'Fail',
}

export const ASSESSMENT_STATUS_MAP = {
  [AssessmentStatus.Open]: AssessmentStatusOpen,
  [AssessmentStatus.Closed]: AssessmentStatusClosed,
  [AssessmentStatus.NoRisksDetected]: AssessmentStatusNoRisksDetected,
  [AssessmentStatus.InProgress]: AssessmentStatusInProgress,
};

/**
 * FIXME: We need to remove these identity types from DB and code.
 */
export enum UnsupportedIdentityTypeCode {
  Individual_Foreign = 'Individual_Foreign',
  Private_Foreign_Company = 'Private_Foreign_Company',
  Public_Foreign_Company = 'Public_Foreign_Company',
}

const UNSUPPORTED_IDENTITY_TYPES_MAP: {
  [key in UnsupportedIdentityTypeCode]: TOption;
} = {
  [UnsupportedIdentityTypeCode.Individual_Foreign]: {
    code: UnsupportedIdentityTypeCode.Individual_Foreign,
    label: 'Individual (Foreign)',
  },
  [UnsupportedIdentityTypeCode.Private_Foreign_Company]: {
    code: UnsupportedIdentityTypeCode.Private_Foreign_Company,
    label: 'Private Company (Foreign)',
  },
  [UnsupportedIdentityTypeCode.Public_Foreign_Company]: {
    code: UnsupportedIdentityTypeCode.Public_Foreign_Company,
    label: 'Public Company (Foreign)',
  },
};

export const ALL_IDENTITY_TYPES_MAP = {
  ...IDENTITY_TYPES_MAP,
  ...UNSUPPORTED_IDENTITY_TYPES_MAP,
};
